import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useUpdateInspectionFormMarkupMutation } from '../../redux/rtkQuery/apiSlice';
import { RootState } from '../../redux/root';

export type MarkupSaveState = 'idle' | 'saving' | 'saved' | 'error';

const useFormMarkupTools = () => {
  const [updateInspectionFormMarkup] = useUpdateInspectionFormMarkupMutation();
  const selectedInspection = useSelector((s: RootState) => s.inspections.selectedInspection);
  // One piece of state, not two. These updates happen after an await, where
  // React 17 does not batch — separate setters would briefly render 'saved'
  // with a null timestamp, and formatting that would throw.
  const [save, setSave] = useState<{ state: MarkupSaveState; at: Date | null }>({
    state: 'idle',
    at: null,
  });

  const updateFormMarkupOnInspection = async markup => {
    setSave(prev => ({ ...prev, state: 'saving' }));
    // RTK Query mutations resolve to { data } or { error } — they only reject
    // via .unwrap(), so a failed save would otherwise look successful and the
    // inspector would never know their work didn't persist.
    const result: any = await updateInspectionFormMarkup({
      id: selectedInspection.id,
      form_markup: markup,
    });

    if (result && result.error) {
      setSave(prev => ({ ...prev, state: 'error' }));
      return false;
    }

    setSave({ state: 'saved', at: new Date() });
    return true;
  };

  return {
    updateFormMarkupOnInspection,
    saveState: save.state,
    lastSavedAt: save.at,
  };
};

export default useFormMarkupTools;
